module.exports = __webpack_public_path__ + "static/img/compony.c604ca74.svg";